<div *ngIf="!hideFooter" class="main-footer">
  <div class="footer-container">
    <div class="footer-columns">
      <div class="footer-col">
        <h4>{{ "Footer.Overview" | translate }}</h4>
        <ul>
          <li>
            <a
              href="https://socpa.org.sa/Socpa/About-Socpa.aspx"
              target="_blank"
            >
              {{ "Footer.AboutAuthority" | translate }}</a
            >
          </li>
          <li>
            <a
              href="https://socpa.org.sa/Socpa/About-Socpa/3021.aspx"
              target="_blank"
            >
              {{ "Footer.QualityPolicy" | translate }}</a
            >
          </li>
          <li>
            <a
              href="https://socpa.org.sa/Socpa/About-Socpa/3070.aspx"
              target="_blank"
            >
              {{ "Footer.ClientCharter" | translate }}</a
            >
          </li>
          <li>
            <a
              href="https://socpa.org.sa/Socpa/About-Socpa/3071.aspx"
              target="_blank"
            >
              {{ "Footer.ClientSatisfaction" | translate }}</a
            >
          </li>
          <li>
            <a
              href="https://sso.socpa.org.sa/?returnUrl=https://eservice.socpa.org.sa//eDashboard.aspx"
              target="_blank"
            >
              {{ "Footer.EServices" | translate }}</a
            >
          </li>
          <li>
            <a href="https://c.socpa.org.sa/Career/Authority" target="_blank">
              {{ "Footer.Careers" | translate }}</a
            >
          </li>
          <li>
            <a
              href="https://socpa.org.sa/Socpa/Contact-Us/Branches.aspx"
              target="_blank"
            >
              {{ "Footer.Branches" | translate }}</a
            >
          </li>
          <li>
            <a
              href="https://socpa.org.sa/Socpa/Contact-Us/Submit-Request.aspx"
              target="_blank"
            >
              {{ "Footer.ContactUs" | translate }}</a
            >
          </li>
        </ul>
      </div>
      <div class="footer-col">
        <h4>{{ "Footer.ImportantLinks" | translate }}</h4>
        <ul>
          <li>
            <a href="https://my.gov.sa/ar" target="_blank">{{
              "Footer.NationalPlatform" | translate
            }}</a>
          </li>
          <li>
            <a href="https://open.data.gov.sa/ar/home" target="_blank">{{
              "Footer.OpenDataPortal" | translate
            }}</a>
          </li>
          <li>
            <a href="https://eparticipation.my.gov.sa/" target="_blank">{{
              "Footer.EParticipation" | translate
            }}</a>
          </li>
          <li>
            <a
              href="https://istitlaa.ncc.gov.sa/ar/Pages/default.aspx"
              target="_blank"
              >{{ "Footer.ConsultationPlatform" | translate }}</a
            >
          </li>
          <li>
            <a href="https://nazaha.gov.sa/Services" target="_blank">{{
              "Footer.ReportCorruption" | translate
            }}</a>
          </li>
        </ul>
      </div>
      <div class="footer-col contact">
        <h4>{{ "Footer.ContactUsTitle" | translate }}</h4>
        <ul>
          <li>
            <a href="tel:8004404444">
              <i class="fa fa-phone"></i>
              8004404444
            </a>
          </li>

          <li>
            <a href="mailto:info@socpa.org.sa">
              <i class="fa fa-envelope"></i>
              info@socpa.org.sa
            </a>
          </li>
          <li>
            <i class="fa fa-map-marker"></i>
            {{ "Footer.Address" | translate }}
          </li>
        </ul>
      </div>
      <div class="footer-col social">
        <h4>{{ "Footer.FollowUs" | translate }}</h4>
        <div class="social-icons">
          <a href="https://x.com/socpa_ksa" target="_blank">
            <i class="social-x">
              <svg
                viewBox="0 0 24 24"
                width="12"
                height="12"
                fill="currentColor"
              >
                <path
                  d="M18.244 2H21.5l-7.19 8.21L22 22h-6.828l-5.34-6.993L3.8 22H.542l7.7-8.79L2 2h6.828l4.83 6.36L18.244 2Zm-2.39 18h1.89L8.1 4H6.09l9.764 16Z"
                />
              </svg>
            </i>
          </a>
          <a href="https://www.instagram.com/socpaksa/" target="_blank">
            <i class="fa fa-instagram"></i>
          </a>

          <a href="https://www.youtube.com/user/socpaksa" target="_blank">
            <i class="fa fa-youtube"></i>
          </a>

          <a href="https://www.linkedin.com/company/socpa" target="_blank">
            <i class="fa fa-linkedin"></i>
          </a>

          <a href="https://www.snapchat.com/@socpa_ksa" target="_blank">
            <i class="fa fa-snapchat"></i>
          </a>
        </div>
      </div>
    </div>

    <div class="footer-bottom">
      <div class="footer-info">
        <div class="links">
          <a
            href="https://socpa.org.sa/Sites/Support/Home.aspx"
            target="_blank"
            >{{ "Footer.FAQ" | translate }}</a
          >
          <a href="https://socpa.org.sa/Socpa/SiteMap.aspx" target="_blank">{{
            "Footer.SiteMap" | translate
          }}</a>
          <a
            href="https://socpa.org.sa/Socpa/Pages/Privacy-Policy.aspx"
            target="_blank"
            >{{ "Footer.Terms" | translate }}</a
          >
          <a
            href="https://socpa.org.sa/Socpa/Pages/Privacy-Policy.aspx"
            target="_blank"
            >{{ "Footer.Privacy" | translate }}</a
          >
        </div>

        <div class="extra-links">
          <a
            href="https://socpa.org.sa/Socpa/Pages/Terms-and-Conditions.aspx"
            target="_blank"
          >
            {{ "Footer.RightsConditions" | translate }}
          </a>
          <a
            href="https://socpa.org.sa/Socpa/Pages/Privacy-Policy.aspx"
            target="_blank"
          >
            {{ "Footer.PrivacyPolicy" | translate }}
          </a>
        </div>
      </div>
      <div class="footer-logos">
        <img src="assets/images/footer/roaya.svg" />
        <img src="assets/images/footer/socpa.svg" />
      </div>
    </div>
  </div>

  <div class="footer-powered">
    <span>{{ "Footer.PoweredBy" | translate }}</span>
    <img
      (click)="goEvento()"
      style="cursor: pointer"
      *ngIf="translate.currentLang == 'en'"
      src="assets/images/footer/evento-logo-en.svg"
    />
    <img
      (click)="goEvento()"
      style="cursor: pointer"
      *ngIf="translate.currentLang == 'ar'"
      src="assets/images/footer/evento-logo.svg"
    />
  </div>
</div>
